import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import AiChat from './ai-chat/AiChat';
import { Tooltip } from 'react-tooltip';

import './aiassistant.css';

const AiAssistant = ({ user, setShowAPIModal }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [isHidden, setIsHidden] = useState(false);
	const [isBotTyping, setIsBotTyping] = useState(false);
	const [pendingBotMessage, setPendingBotMessage] = useState(null);
	const [messages, setMessages] = useState([]);

	const closeIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="13"
			height="13"
			viewBox="0 0 13 13"
			fill="none"
		>
			<path
				d="M0.269726 10.5203L4.75551 6.03448L0.269726 1.54869C0.184675 1.46491 0.117053 1.36513 0.0707599 1.25508C0.0244671 1.14504 0.000419946 1.02692 5.45139e-06 0.907533C-0.000409043 0.788149 0.0228174 0.669864 0.0683449 0.559501C0.113872 0.449138 0.1808 0.348882 0.265267 0.264514C0.349735 0.180146 0.45007 0.113336 0.560487 0.0679389C0.670903 0.0225415 0.789215 -0.000545414 0.908598 9.78051e-06C1.02798 0.000564975 1.14607 0.0247513 1.25606 0.0711737C1.36605 0.117596 1.46576 0.185336 1.54944 0.270486L6.03372 4.75627L10.5195 0.270486C10.6032 0.185336 10.7029 0.117596 10.8129 0.0711737C10.9229 0.0247513 11.041 0.000564975 11.1604 9.78051e-06C11.2797 -0.000545414 11.398 0.0225415 11.5085 0.0679389C11.6189 0.113336 11.7192 0.180146 11.8037 0.264514C11.8881 0.348882 11.9551 0.449138 12.0006 0.559501C12.0461 0.669864 12.0694 0.788149 12.0689 0.907533C12.0685 1.02692 12.0445 1.14504 11.9982 1.25508C11.9519 1.36513 11.8843 1.46491 11.7992 1.54869L7.31193 6.03448L11.7977 10.5203C11.8828 10.604 11.9504 10.7038 11.9967 10.8139C12.043 10.9239 12.067 11.042 12.0674 11.1614C12.0679 11.2808 12.0446 11.3991 11.9991 11.5095C11.9536 11.6198 11.8866 11.7201 11.8022 11.8044C11.7177 11.8888 11.6174 11.9556 11.507 12.001C11.3965 12.0464 11.2782 12.0695 11.1588 12.069C11.0395 12.0684 10.9214 12.0442 10.8114 11.9978C10.7014 11.9514 10.6017 11.8836 10.518 11.7985L6.03372 7.31269L1.54793 11.7985C1.37796 11.9659 1.14871 12.0594 0.910128 12.0586C0.671542 12.0577 0.442949 11.9627 0.274142 11.7941C0.105336 11.6254 0.00999439 11.397 0.00888485 11.1584C0.0077753 10.9198 0.100988 10.6904 0.268219 10.5203H0.269726Z"
				fill="white"
			/>
		</svg>
	);

	const AIChatBox = (
		<div
			className={`font-inter backdrop-blur-[10px] fixed top-0 left-0 w-full h-full bg-[#00000063] z-[9999] ${
				isHidden ? 'hidden' : 'block'
			}`}
		>
			<div className="fixed w-[430px] top-[10%] right-[68px] h-[85%] rounded-xl overflow-hidden flex flex-col">
				<div className="px-6 py-4 flex items-center justify-between bg-ec-primary">
					<div className="flex items-center gap-3">
						<div className="w-[14px] h-[14px] bg-[#1DE61D] rounded-full"></div>
						<h2 className="text-[16px] text-white">EasyCommerce AI</h2>
					</div>

					<div className="flex items-center gap-4">
						{/* Minimize Button */}
						<Tooltip
							id="ai-hide-btn"
							place="bottom-end"
							style={{ backgroundColor: '#fff', color: '#7351fd', border: '1px solid #ccc', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
						/>
						<button
							data-tooltip-id="ai-hide-btn"
							data-tooltip-content="Minimize"
							onClick={() => setIsHidden(true)}
							className="text-3xl text-white font-bold w-3.5 h-4 flex items-center justify-center"
						>
							<div className="w-3.5 h-0.5 bg-white"></div>
						</button>

						<Tooltip
							id="ai-reset-btn"
							place="bottom-end"
							style={{ backgroundColor: '#ffffff', color: '#7351fd', border: '1px solid #ccc', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
						/>
						<button
							data-tooltip-id="ai-reset-btn"
							data-tooltip-content="Reset"
							onClick={() => {
								setIsBotTyping(false);
								setPendingBotMessage(null);
								setMessages([]);
							}}
							className="w-5 h-6 flex items-center justify-center"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="512"
								height="512"
								viewBox="0 0 512 512"
								fill="none"
							>
								<path
									d="M256 42.6667C200.04 42.7455 146.374 64.9098 106.667 104.341V64.0001C106.667 58.3421 104.419 52.9159 100.418 48.9151C96.4175 44.9144 90.9912 42.6667 85.3333 42.6667C79.6753 42.6667 74.2491 44.9144 70.2483 48.9151C66.2476 52.9159 64 58.3421 64 64.0001V149.333C64 154.991 66.2476 160.418 70.2483 164.418C74.2491 168.419 79.6753 170.667 85.3333 170.667H170.667C176.325 170.667 181.751 168.419 185.752 164.418C189.752 160.418 192 154.991 192 149.333C192 143.675 189.752 138.249 185.752 134.248C181.751 130.248 176.325 128 170.667 128H143.275C172.574 102.226 209.821 87.2702 248.809 85.626C287.797 83.9818 326.171 95.7482 357.536 118.964C388.902 142.18 411.364 175.444 421.179 213.212C430.995 250.98 427.571 290.971 411.479 326.521C395.387 362.071 367.598 391.033 332.743 408.58C297.888 426.127 258.072 431.2 219.931 422.953C181.79 414.706 147.626 393.637 123.135 363.257C98.6426 332.878 85.301 295.023 85.3333 256C85.3333 250.342 83.0857 244.916 79.0849 240.915C75.0841 236.914 69.6579 234.667 64 234.667C58.342 234.667 52.9158 236.914 48.915 240.915C44.9142 244.916 42.6666 250.342 42.6666 256C42.6666 298.193 55.1784 339.439 78.6198 374.522C102.061 409.604 135.379 436.948 174.361 453.094C213.342 469.241 256.237 473.466 297.619 465.234C339.002 457.003 377.014 436.685 406.849 406.85C436.685 377.014 457.003 339.002 465.234 297.619C473.466 256.237 469.241 213.343 453.094 174.361C436.948 135.379 409.604 102.061 374.522 78.6199C339.439 55.1785 298.193 42.6667 256 42.6667Z"
									fill="white"
								/>
							</svg>
						</button>

						<Tooltip
							id="ai-close-btn"
							place="bottom-end"
							style={{ backgroundColor: '#fff', color: '#7351fd', border: '1px solid #ccc', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
						/>
						<button
							data-tooltip-id="ai-close-btn"
							data-tooltip-content="End Conversation"
							className="text-gray-400 hover:text-gray-200"
							onClick={() => {
								setIsOpen(false);
								setIsHidden(false);
								setPendingBotMessage(null);
								setIsBotTyping(false);
							}}
						>
							{closeIcon}
						</button>
					</div>
				</div>
				<div className="grow w-full bg-white p-6">
					<AiChat
						user={user}
						isBotTyping={isBotTyping}
						setIsBotTyping={setIsBotTyping}
						pendingBotMessage={pendingBotMessage}
						setPendingBotMessage={setPendingBotMessage}
						messages={messages}
						setMessages={setMessages}
					/>
				</div>
			</div>
		</div>
	);

	return (
		<>
			{isBotTyping && !pendingBotMessage && (
				<div className="fixed bottom-7 right-10 scale-50 z-50">
					<div className="inline-block max-w-[310px] p-3 rounded-full bg-white border border-ec-border">
						<div className="flex items-center gap-2">
							<span className="w-2.5 h-2.5 rounded-full typing-dot inline-block"></span>
							<span
								className="w-2.5 h-2.5 rounded-full typing-dot inline-block"
								style={{ animationDelay: '0.12s' }}
							></span>
							<span
								className="w-2.5 h-2.5 rounded-full typing-dot inline-block"
								style={{ animationDelay: '0.24s' }}
							></span>
						</div>
					</div>
				</div>
			)}

			<button
				data-tooltip-id="ai-assistant-btn"
				data-tooltip-content="EasyCommerce AI"
				className="ai-generate animate-[wiggle_3s_ease-in-out_infinite] flex items-center gap-2 justify-center text-white w-[43px] h-ec-input rounded-[8px] fixed bottom-10 right-10"
				onClick={() => {
					setIsOpen(true);
					setIsHidden(false);
				}}
			>
				<svg
					className="scale-[1.3]"
					xmlns="http://www.w3.org/2000/svg"
					width="17"
					height="17"
					viewBox="0 0 17 17"
					fill="none"
				>
					<path
						d="M13.4235 9.76927C9.65184 11.0154 8.39589 12.2716 7.14976 16.043C7.04724 16.3531 6.6088 16.3531 6.5063 16.043C5.26021 12.2713 4.00401 11.0154 0.232545 9.76927C-0.0775151 9.66675 -0.0775151 9.22831 0.232545 9.1258C4.00422 7.87972 5.26017 6.62352 6.5063 2.85205C6.60882 2.54199 7.04725 2.54199 7.14976 2.85205C8.39585 6.62373 9.65205 7.87967 13.4235 9.1258C13.7336 9.22833 13.7336 9.66676 13.4235 9.76927Z"
						fill="white"
					/>
					<path
						d="M16.1579 3.57531C14.2725 4.19795 13.6441 4.82641 13.0206 6.71261C12.9698 6.86764 12.7506 6.86764 12.6989 6.71261C12.0763 4.82722 11.4478 4.1988 9.56159 3.57531C9.40655 3.52447 9.40655 3.30526 9.56159 3.25358C11.447 2.63094 12.0754 2.00248 12.6989 0.116274C12.7497 -0.0387581 12.9689 -0.0387581 13.0206 0.116274C13.6433 2.00166 14.2717 2.63009 16.1579 3.25358C16.313 3.30442 16.313 3.52363 16.1579 3.57531Z"
						fill="white"
					/>
				</svg>
			</button>

			<Tooltip
				id="ai-assistant-btn"
				place="bottom"
				style={{ backgroundColor: '#7351fd', color: 'white', border: '1px solid #ccc', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
			/>

			{isOpen && createPortal(AIChatBox, document.body)}
		</>
	);
};
export default AiAssistant;
